<template>
  <div class="home">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor">
      
    </div>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from 'wangeditor'
import emojiJson from "./emoji.json"
export default {
  data() {
    return {
      editor: null,
      editorData: '',
      actionUrl:'',
      emojiList:emojiJson
    }
  },
  props: {
    explain:{
      default:''
    }
  },

  watch: {
    explain(value){
      this.editor.txt.html(value)
      this.editor.selection.moveCursor(this.editor.$textElem.elems[0],false);
    }
  },

  
  mounted() {
    const editor = new wangEditor(this.$refs.editor)
    // 配置 onchange 回调函数，将数据同步到 vue 中
    editor.config.onchange = (newHtml) => {
      console.log(newHtml,7777)
      this.editorData = newHtml
      this.$emit('editorData', this.editorData)
    }
        editor.config.showLinkImg = false
        // editor.config.uploadImgShowBase64  = true // base 64 存储图片
        editor.config.uploadImgServer = '/supplierapi/upload'// 配置服务器端地址
        // editor.uploadImgHeaders = {token: this.$store.state.token, }// 自定义 header
        editor.uploadFileName = 'file' // 后端接受上传文件的参数名
        // editor.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
        // editor.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
        editor.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间

    editor.config.zIndex = 500;

    editor.config.menus=[
          'bold', // 粗体 
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'underline', // 下划线 
          'strikeThrough', // 删除线
          'foreColor', // 文字颜色
          'backColor', // 背景颜色
          'justify', // 对齐方式
          'list',
          'justify',
          'image',
          'emoticon',
          'table'
        ]

      //上传图片
      editor.config.customUploadImg = function (files, insert) {//对上传的图片进行处理，图片上传的方式
        var data = new FormData()
        data.append("file", files[0])
              $.ajax({
                  url: "./supplierapi/upload",
                  type: "post",
                  data: data,
                  processData: false,
                  contentType: false,
                  success: function (data) {
                    console.log(data)
                      // var imgUrl=data.newName
                      let imgUrl = data.data.full_path
      //这里是对图片格式进行处理，我这里因为是要保存到本地服务器上，将图片前缀修改
                      editor.cmd.do('insertHTML', '<img style="width: 200px;" src="'+ imgUrl+'" alt="">')
                  },
                  error: function () {
                      alert("图片上传错误")
                  }
              })
      }

      editor.config.emotions = [
        {
          title:'默认',
          type:'image',
          content:this.emojiList
        }
      ]

      editor.config.emotionsShow = 'icon';
    editor.config.height = 200

    // 创建编辑器
    editor.create()
    this.editor = editor  
   
  },
  methods: {
    getEditorData() {
      // 通过代码获取编辑器内容
      const data = this.editor.txt.html()
      // alert(data)
    }
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy()
    this.editor = null
  }
}
</script>

<style lang="less" scoped>
.home {
  width: 1024px;
  height: 240px;
  // margin: auto;
  position: relative;
  text-align: left;
  margin-top:30px;
  .btn {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px 10px;
    cursor: pointer;
  }
  h3 {
    margin: 30px 0 15px;
  }
}
</style>
